import { CompanyBdc } from './companies-bdc.model';

export class GetMetricsBdcResponse {
  companies: CompanyBdc[];

  constructor(companies: CompanyBdc[]) {
    this.companies = companies;
  }
}
